import React, { Fragment, useEffect, useState } from 'react';
import Navbar2 from '../../components/Navbar2'
import Hero4 from '../../components/hero4';
import About4 from '../../components/about4';
import ProjectSectionS4 from '../../components/ProjectsS4';
import ServiceSection3 from '../../components/Services3';
import Pricing from '../../components/Pricing';
import BlogSectionS2 from '../../components/BlogSectionS2';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.svg'
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../hooks/useFetch';
import { fetchBlogs, fetchContact, fetchPricing, fetchprojects, fetchServices, fetchTeams, fetchTestimonials } from '../../api/api';


const HomePage4 = () => {
    const { i18n } = useTranslation();
    const [lang, setLang] = useState();
    useEffect(() => {
        setLang(i18n.language)
    }, [i18n.language]);
    const {
        data: projects,
        error: projectsError,
        isLoading: projectsIsloading,
    } = useFetch(["projects"], fetchprojects);

    const {
        data: blogsData,
        isLoading: blogsIsLoading,
        error: blogsIsError
    } = useFetch(["blogs"], fetchBlogs);
    const {
        data: pricingData,
        isLoading: pricingIsLoading,
        error: pricingIsError
    } = useFetch(["pricing"], fetchPricing);
    const {
        data: ServicesData,
        isLoading: ServicesIsLoading,
        error: ServicesIsError
    } = useFetch(["Services"], fetchServices);
    const { data, isLoading, error } = useFetch(["contact"], fetchContact);
    console.log(blogsIsError, pricingIsError, projectsError, ServicesIsError, error);
    return (
        <Fragment>
            <Navbar2 Logo={Logo} hclass={'wpo-header-style-3'} />
            <Hero4 lang={lang} />
            <About4 />
            <ServiceSection3 services={ServicesData?.data?.data} ServicesIsLoading={ServicesIsLoading} ServicesIsError={ServicesIsError} />
            <ProjectSectionS4 projects={projects?.data?.data} projectsIsloading={projectsIsloading} projectsError={projectsError} />
            <Pricing pricingData={pricingData?.data?.pricingData} pricingIsLoading={pricingIsLoading} pricingIsError={pricingIsError} />
            <BlogSectionS2 blogs={blogsData?.data?.data} blogsIsLoading={blogsIsLoading} blogsIsError={blogsIsError} />
            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage4;